import { render } from "./BuyForm.vue?vue&type=template&id=a0a6425c&scoped=true"
import script from "./BuyForm.vue?vue&type=script&lang=js"
export * from "./BuyForm.vue?vue&type=script&lang=js"

import "./BuyForm.vue?vue&type=style&index=0&id=a0a6425c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a6425c"]])

export default __exports__